import React from 'react';
import { BadgeCheck, CreditCard, Star } from 'lucide-react';
export default function FeaturesStrip() {
  return <section className="bg-[#faf8f5] border-b border-gray-200 pb-5"><div className="max-w-7xl mx-auto px-4 grid sm:grid-cols-3 gap-4">{[
    [BadgeCheck, 'Verified drivers', 'Driver documents reviewed before approval.'],
    [CreditCard, 'Payment in the app', 'Keep booking and payment in one place.'],
    [Star, 'Reviews after the ride', 'Driver feedback from completed trips.']
  ].map(([Icon, title, text]) => <div key={title} className="flex gap-3"><Icon className="w-5 h-5 mt-1 shrink-0 text-brand-orange-500" /><div><h2 className="text-sm font-semibold text-brand-black">{title}</h2><p className="mt-1 text-xs leading-relaxed text-gray-500">{text}</p></div></div>)}</div></section>;
}
